import { supabase } from './supabase';
import { extractFnError } from './odooInvoices';

// KPI CA & Bénéfice temps réel (Edge Function `network-revenue`, super_admin).

export type RevenuePeriod = 'day' | 'week' | 'month';

export interface NetworkRevenue {
  ok: boolean;
  period: RevenuePeriod;
  active_subs: number;
  mrr_abo_cents: number;
  mrr_options_cents: number;
  mrr_cents: number;
  option_counts: Record<string, number>;
  commission_encaisse_cents: number;
  commission_recouvrer_cents: number;
  commission_orders: number;
  fixed_costs_cents: number;
  recurring_period_cents: number;
  fixed_period_cents: number;
  ca_period_cents: number;
  net_period_cents: number;
  ca_month_cents: number;
  net_month_cents: number;
  net_year_cents: number;
  arr_recurring_cents: number;
  error?: string;
}

const EMPTY: NetworkRevenue = {
  ok: false, period: 'month', active_subs: 0, mrr_abo_cents: 0, mrr_options_cents: 0, mrr_cents: 0, option_counts: {},
  commission_encaisse_cents: 0, commission_recouvrer_cents: 0, commission_orders: 0,
  fixed_costs_cents: 0, recurring_period_cents: 0, fixed_period_cents: 0, ca_period_cents: 0, net_period_cents: 0,
  ca_month_cents: 0, net_month_cents: 0, net_year_cents: 0, arr_recurring_cents: 0,
};

export async function loadNetworkRevenue(period: RevenuePeriod = 'month'): Promise<NetworkRevenue> {
  const { data, error } = await supabase.functions.invoke('network-revenue', { body: { period } });
  if (error) return { ...EMPTY, error: await extractFnError(error, 'Chargement CA impossible.') };
  const res = (data ?? {}) as NetworkRevenue;
  if (!res.ok) return { ...EMPTY, error: res.error ?? 'Échec.' };
  return res;
}

export async function setFixedCosts(cents: number): Promise<{ ok: boolean; error?: string }> {
  const { data, error } = await supabase.functions.invoke('network-revenue', {
    body: { action: 'set_costs', monthly_fixed_costs_cents: cents },
  });
  if (error) return { ok: false, error: await extractFnError(error, 'Enregistrement impossible.') };
  const res = (data ?? {}) as { ok?: boolean; error?: string };
  if (!res.ok) return { ok: false, error: res.error ?? 'Échec.' };
  return { ok: true };
}
